export class KanbanListSwitcher {
    constructor() {
        const switchToListButton = document.querySelector('[data-switch-to-list] > input[type=radio]');

        if (switchToListButton === null) {
            return;
        }

        const localStorageKey = switchToListButton.name;
        this.#init(localStorageKey);
    }

    #init(localStorageKey) {
        const viewMode = window.localStorage.getItem(localStorageKey) ?? 'kanban';
        const switchToListButton = document.querySelector('[data-switch-to-list] > input[type=radio]');
        const switchToKanbanButton = document.querySelector('[data-switch-to-kanban] > input[type=radio]');

        if (switchToKanbanButton === null) {
            return;
        }

        switchToListButton.addEventListener('click', () => {
            this.#switchToListView(localStorageKey);
        });
        switchToKanbanButton.addEventListener('click', () => {
            this.#switchToKanbanView(localStorageKey);
        });

        if (viewMode === 'list') {
            switchToListButton.click();
        } else {
            switchToKanbanButton.click();
        }
    }

    #switchToListView(localStorageKey) {
        window.localStorage.setItem(localStorageKey, 'list');
        for (const kanban of document.querySelectorAll('.kanban')) {
            kanban.classList.remove('kanban-view');
        }
    }

    #switchToKanbanView(localStorageKey) {
        window.localStorage.setItem(localStorageKey, 'kanban');
        for (const kanban of document.querySelectorAll('.kanban')) {
            kanban.classList.add('kanban-view');
        }
    }
}

new KanbanListSwitcher();
